export enum WFXBuyersEnum {
    GAP = "GAP",
    WALMART = "WALMART",
    Shahi = "Shahi",
}